import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgxEchartsModule } from 'ngx-echarts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatBadgeModule } from '@angular/material/badge';

import {
  TranslateModule,
  TranslateLoader,
  TranslateService
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { AfterLoginComponent } from './layout/after-login/after-login.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SetInterceptorService } from './core/interceptor/set-interceptor.service';
import { GetInterceptorService } from './core/interceptor/get-interceptor.service';
import { ModalsModule } from './modals/modals.module';
import { AfterLoginSharedModule } from './shared/after-login.shared.module';
import { ToastrModule } from 'ngx-toastr';
import { InitialService } from './core/services/initial.service';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslatedPaginatorIntl } from './core/services/translated-paginator-intl.service';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
export function initialServiceFactory(
  initialService: InitialService
): () => Promise<void> {
  return () => initialService.setUpGoogleScript();
}

@NgModule({
  declarations: [AppComponent, AfterLoginComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NgxUiLoaderModule,
    ModalsModule,
    MatMenuModule,
    MatSidenavModule,
    MatIconModule,
    MatBadgeModule,
    AfterLoginSharedModule,
    HttpClientModule,
    GooglePlaceModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),

    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],

  exports: [TranslateModule],
  providers: [
    TranslateService,
    {
      provide: APP_INITIALIZER,
      useFactory: initialServiceFactory,
      deps: [InitialService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SetInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GetInterceptorService,
      multi: true
    },
    {
      provide: MatPaginatorIntl,
      useClass: TranslatedPaginatorIntl
    },
    BrowserAnimationsModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
